import METHODS from './_http-methods';

/**
 * Sets the default HTTP method and headers for the configuration object.
 *
 * @param  {Object} options: options to configure the request.
 * @return {Object}
 */
export default function defaultPOST(options) {
  const config = Object.assign({
    headers: {'Content-Type': 'application/json'},
    method: 'POST',
    processData: true,
  }, options);

  // TODO: should remove this isGET?
  const isGET = METHODS.fromUrl.test(config.method);

  if (isGET) {
    delete config.headers['Content-Type'];
  }

  return config;
}
